module.exports = __webpack_public_path__ + "static/media/user.de5e8893.svg";